import { Box } from '@mui/material';
import Image from 'next/image';

import { useLocale } from 'hooks/useLocale';

type Size = 'medium';

const sizeLookup: Record<Size, number> = {
  medium: 40,
};

interface Props {
  size?: Size;
}

const SaudiRewardsLogo = ({ size = 'medium' }: Props) => {
  const { locale } = useLocale();

  return (
    <Box
      sx={{
        bgcolor: 'common.white',
        height: sizeLookup[size],
        minWidth: sizeLookup[size],
        borderRadius: 1,
        position: 'relative',
      }}
    >
      <Image
        src={`/images/saudi-rewards/brand-logo-saudi-rewards-${locale}.webp`}
        fill
        alt="Saudi Rewards logo"
        style={{
          objectFit: 'contain',
          padding: '0 2px',
        }}
        placeholder="empty"
        unoptimized
      />
    </Box>
  );
};

export default SaudiRewardsLogo;
